import * as React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { CloseIcon } from "../../../icons";
import { useEffect, useState, useRef } from "react";
import FormBuildTabs from "../../../plugins/formBuilder/FormBuildTabs";
import { useAxios } from "../../../utils/useAxios";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

interface ModelProps {
  isOpen: boolean;
  onClose: () => void;
  formId: string;
  source?: any;
  crudOp?: any;
  //   children: React.ReactNode;
}

export default function MuiModel({
  isOpen,
  onClose,
  formId,
  source,
  crudOp,
}: ModelProps) {
  const {
    res: formRes,
    mutate,
    isPending,
  } = useAxios({
    url: "/api/auth/form",
  });

  const previousFormIdRef = useRef<string | null>(null);
  const [resData, setResData] = useState<any>([]);

  useEffect(() => {
    if (!formId) return;
    const formIdFinal = formId === "consignee" ? "shipper" : formId;
    mutate({ formId: formIdFinal });
  }, [formId]);

  useEffect(() => {
    if (!isPending || formRes) {
      setResData(formRes?.data?.data);
    }
  }, [formRes]);

  const openlist = () => {
    onClose();
  };

  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={isOpen}
        maxWidth="lg"
        fullWidth={true}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {formId === "consignee" ? "Consignee" : resData?.title}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Div>
            <FormBuildTabs
              getformData={resData}
              openlist={openlist}
              source={source}
              crudOp={crudOp}
            />
          </Div>
        </DialogContent>
        {/* <DialogActions>
          <Button autoFocus onClick={onClose}>
            Save changes
          </Button>
        </DialogActions> */}
      </BootstrapDialog>
    </React.Fragment>
  );
}

const Div = styled("div")`
  .inpop {
    width: 100% !important;
  }
`;
